import bp2 from "../assets/bp-2.jpg"
import bp3 from "../assets/bp-3.jpg"
import bp4 from "../assets/bp-4.jpg"
import bp5 from "../assets/bp-5.jpg"
import bp6 from "../assets/bp-6.jpg"
import bp7 from "../assets/bp-7.png"
import bp8 from "../assets/bp-8.jpg"
import bp19 from "../assets/bp-19.jpg"
import bp10 from "../assets/bp-10.jpg"
import bp11 from "../assets/bp-11.jpg"
import bp12 from "../assets/bp-12.png"
import bp13 from "../assets/bp-13.jpg"
import bp14 from "../assets/bp-14.jpg"
import bp16 from "../assets/bp-16.jpg"
import bp15 from "../assets/bp-15.jpg"
import bp17 from "../assets/bp-17.jpg"
import bp18 from "../assets/bp-18.jpg"
import bp20 from "../assets/bp-20.jpg"
import bp21 from "../assets/bp-21.jpg"
import bp22 from "../assets/bp-22.jpg"
import bp23 from "../assets/bp-23.jpg"
import bp24 from "../assets/bp-24.jpg"
import bp25 from "../assets/bp-25.jpg"

const BPImages = [
  bp2, bp3, bp4, bp5, bp6, bp7, bp8,
  bp10, bp11, bp12, bp13, bp14, bp15, bp16,
  bp17, bp18, bp19, bp20, bp21, bp22, bp23,
  bp24, bp25
    
 ]
 export default BPImages